"use strict";

angular.module("core").factory("Workflow", function($state) {
    var formsData = {};
    var currentSection = "";

    return {
        startFromScratchAt: function(section, params) {
            formsData = {};
            currentSection = section;
            return $state.go(currentSection, params);
        },
        saveAndContinueAt: function(formData, nextSection, params) {
            formsData[currentSection] = formData;

            if (currentSection != nextSection) {
                currentSection = nextSection;
                formsData[currentSection] = undefined;
            }

            return $state.go(currentSection, params);
        },
        getFormData: function(section) {
            currentSection = section;
            return formsData[currentSection];
        },
        addToFormData: function(section, key, value) {
            if (formsData[section]) {
                formsData[section][key] = value;
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/workflow/workflow.factory.js
// module id = 455
// module chunks = 0